@if (Contract) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h2>
          Viewing Contract Details for {{ Contract.contractName }}
          @if (Vendor && Vendor.legalName) {
            <span>{{ ' - ' + Vendor.legalName }}</span>
          }
        </h2>
      </div>
    </div>
    <div class="row py-3">
      <app-display-card>
        <div class="inner-panel rounded">
          <app-contract-details></app-contract-details>
        </div>
      </app-display-card>
    </div>
  </div>
}
